export class MonthQuotationType {
  static get NewMonth () {
    return 1
  }
  static get RemoveMonth () {
    return 2
  }
  static get ReturnMonth () {
    return 3
  }
  static get MoveMonth () {
    return 4
  }
  static get Discount () {
    return 5
  }
  static get RenewMonth () {
    return 6
  }
  static get UnlimitedMonth () {
    return 7
  }

  static MonthQuotationTypeName (MonthQuotationType) {
    let tmpType = parseInt(MonthQuotationType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '新裝'
        break
      case 2:
        name = '拆機'
        break
      case 3:
        name = '回裝'
        break
      case 4:
        name = '移機'
        break
      case 5:
        name = '折扣'
        break
      case 6:
        name = '續約'
        break
      case 7:
        name = '不定量'
        break
    }
    return name
  }
}
